const TariffsMainView = () => import('@/views/superadmin/tariffs/TariffsMainView')
const TariffsView = () => import('@/views/superadmin/tariffs/TariffsView')
const TariffChangeTasksView = () => import('@/views/superadmin/tariffs/TariffChangeTasksView')
const TariffsPauseTasksView = () => import('@/views/superadmin/tariffs/TariffsPauseTasksView')
const TariffsResumeTasksView = () => import('@/views/superadmin/tariffs/TariffsResumeTasksView')
const TariffsExtensionTasksView = () => import('@/views/superadmin/tariffs/TariffsExtensionTasksView')
const TariffsArchivedView = () => import('@/views/superadmin/tariffs/TariffsArchivedView')

export default {
  path: 'tariffs',
  redirect: { name: 'TariffsSuperAdmin' },
  name: 'TariffsMainSuperAdmin',
  component: TariffsMainView,
  meta: { label: 'Тарифы' },
  children: [
    {
      path: 'main',
      name: 'TariffsSuperAdmin',
      component: TariffsView,
      meta: { label: 'Тарифы' },
    },
    {
      path: 'archived',
      name: 'TariffsArchivedSuperAdmin',
      component: TariffsArchivedView,
      meta: { label: 'Архивные тарифы' }
    },
    {
      path: 'change',
      name: 'TariffChangeTasksSuperAdmin',
      component: TariffChangeTasksView,
      meta: { label: 'Смена тарифа' }
    },
    {
      path: 'extend',
      name: 'TariffsExtensionTasksSuperAdmin',
      component: TariffsExtensionTasksView,
      meta: { label: 'Продление тарифов' }
    },
    {
      path: 'pause',
      name: 'TariffsPauseTasksSuperAdmin',
      component: TariffsPauseTasksView,
      meta: { label: 'Пауза тарифов' }
    },
    {
      path: 'resume',
      name: 'TariffsResumeTasksSuperAdmin',
      component: TariffsResumeTasksView,
      meta: { label: 'Возобновление тарифов' }
    },
  ]
}